import React, { FC } from 'react'

import { IconDocumentPngProps } from './IconDocumentPng.types'
import * as Styled from './styles/IconDocumentPng.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentPng: FC<IconDocumentPngProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentPngProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconDocumentPngProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M50 73.2h-7.26a4 4 0 0 0-4 4v25.2a4 4 0 0 0 8 0v-6.5H50a11.7 11.7 0 0 0 8.11-2.9 11.09 11.09 0 0 0 3.33-8.48 11.09 11.09 0 0 0-3.33-8.48A11.7 11.7 0 0 0 50 73.2zm2.69 14a3.72 3.72 0 0 1-2.3.76h-3.65V81.2h3.58a3.72 3.72 0 0 1 2.36.75 4.85 4.85 0 0 1 0 5.21zm64.07.3h-5.25a4 4 0 1 0 0 8h1.25v3.17c-1.92.25-4.29.24-6-.77-.48-.29-1.95-1.18-2.48-4.39-1.49-9.08 3.19-10.92 4.63-11.26.39-.09 3.12-.39 3.63.77a4 4 0 0 0 7.32-3.23c-2.63-6-9.5-6.09-12.77-5.33-1.38.33-13.44 3.69-10.7 20.35.94 5.69 3.93 8.56 6.28 10a15.69 15.69 0 0 0 8.1 2 24.07 24.07 0 0 0 7.25-1.16 4 4 0 0 0 2.71-3.79V91.5a4 4 0 0 0-3.97-4zM86.87 73.2a4 4 0 0 0-4 4v12L73.4 75a4 4 0 0 0-7.33 2.22v25.2a4 4 0 0 0 8 0v-12l9.47 14.21a4 4 0 0 0 7.33-2.22V77.2a4 4 0 0 0-4-4z' />
        <path d='M135.92 35.21a3.93 3.93 0 0 0-.15-.5c0-.08 0-.17-.08-.25a4 4 0 0 0-.27-.51c0-.06-.06-.12-.09-.17a4 4 0 0 0-.49-.6l-32-32a4 4 0 0 0-.59-.49L102 .57a4 4 0 0 0-.48-.26l-.27-.08a3.91 3.91 0 0 0-.48-.15A4 4 0 0 0 100 0H40a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h80a16 16 0 0 0 16-16V36a4 4 0 0 0-.08-.79zM104 13.66 122.34 32H104zM120 152H40a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8h56v28a4 4 0 0 0 4 4h28v104a8 8 0 0 1-8 8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentPng
